<template src="../../templates/card/bull-card.pug" lang="pug" />


<script>
import Modal from "@/views/form/Modal.vue"
import {mapActions, mapGetters} from "vuex"
import {format} from "date-fns"

export default {
    name: "BullCard",
    components: {
        Modal,
    },
    props: ['bullToView'],
    data() {
        return {
            bull: {}
        }
    },
    computed: {
        ...mapGetters([
            'selectedFarm',
            'bulls'
        ]),
        birthday() {
            return format(new Date(this.bull.birthday * 1000), 'YYYY-MM-DD')
        },
    },
    created() {
        this.bull = {
            id: this.bullToView.id,
            birthday: this.bullToView.birthday,
            buckleNumber: this.bullToView.buckleNumber,
            building:
                    this.bullToView.building === null
                            ? this.selectedFarm.buildings[0].id
                            : this.bullToView.building,
            type: this.bullToView.type,
            bullRating: {
                id: this.bullToView.bullRating.id,
                fertility: this.bullToView.bullRating.fertility,
                milkProduction: this.bullToView.bullRating.milkProduction,
                udderHealth: this.bullToView.bullRating.udderHealth,
                sicknessProprensity: this.bullToView.bullRating.sicknessProprensity
            },
            isBought: this.bullToView.isBought
        }
    },
    methods: {
        close() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="sass">
@import '../../sass/mixin/color'
@import '../../sass/mixin/flex'

#bull-card-modal
    .modal-container
        .modal-footer
            .button-cancel
                width: 100%
        .modal-header
            background-color: $dd-light-orange
            color: white
        .modal-body
            form
                input, input:focus, input:valid, .multiselect
                    border-left: 8px solid $dd-light-orange
                .select
                    @include flex-center
                    .form-select
                        width: 100%
                        height: 40px
                        border-left: 8px solid $dd-light-orange
                        border-bottom: none
                        border-right: none
                        border-top: transparent
                        padding: 0.25em
                        font-size: 16px
                        font-weight: bold
                        -webkit-appearance: none
                        -moz-appearance: none
                        appearance: none
                .rating-material
                    @include flexbox
                    @include flex-direction(row)
                    @include justify-content(space-around)
                    label
                        color: $grey2
                        font-size: 1em
                        font-weight: 700
                        width: 35px
                        height: 35px
                        border-radius: 50%
                        border-style: solid
                        border-color: $dd-light-orange
                        border-width: 1px
                        display: grid
                        place-items: center
                        background: white
                        transition: 0.2s ease-in-out
                    input
                        position: absolute
                        width: 35px
                        height: 35px
                        border-radius: 50%
                        opacity: 0
                        background-color: $grey2
                        &:checked + label
                            background: $dd-light-orange
                            color: white

</style>